module.exports = "/_next/static/pages/partners/fd5059043ad36648d512056c9ea77523.png";